<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      unit="销货退货单"
      edit-title
      id-key="DocId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      :show-save-button="!readonly"
      :close-on-saved="true"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <el-input v-model="data.DocNo" :placeholder="readonly ? '' : '请输入单据编号'" :disabled="readonly" v-if="noEdit"></el-input>
              <span v-else>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <el-date-picker
                v-model="data.DocDate"
                :placeholder="readonly ? '' : '请选择日期'"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :editable="false"
                v-if="!readonly"
              ></el-date-picker>
              <span v-else>{{ data.DocDate.split(' ')[0] }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称" prop="CustomerId">
              <customer @restaurants="setSupplier" :state="data.CustomerName" />
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="!readonly">
            <el-form-item label="销货单号" prop="SaDocNo">
              <div @click="addOrder">
                <el-input
                  v-model="data.SaDocNo"
                  :placeholder="readonly ? '' : '请选择销货单号'"
                  readonly
                  @focus="addOrder"
                  :disabled="readonly"
                  style="width: 220px"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款条件" prop="ReceiptConditionId">
              <el-select v-model="data.ReceiptConditionId" :placeholder="readonly ? '' : '请选择'" clearable :disabled="readonly" style="width: 100%">
                <el-option
                  v-for="item in recCon"
                  :key="item.ReceiptConditionId"
                  :label="item.ReceiptConditionName"
                  :value="item.ReceiptConditionId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="票据类型">
              <invoice-select v-model="data.InvoiceType" @change="invoiceChange" :clearable="false" />
              <!-- {{data.InvoiceType}} -->
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="data.NeedInvoice">
            <el-form-item label="发票号码" prop="InvoiceNo">
              <el-input v-model="data.InvoiceNo" :placeholder="readonly ? '' : '请输入发票号码'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="data.NeedInvoice">
            <el-form-item label="发票金额" prop="InvoiceAmount">
              <el-input v-model="data.InvoiceAmount" :placeholder="readonly ? '' : '请输入发票金额'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="退货方式">
              <el-select v-model="data.FreightMode" :placeholder="readonly ? '' : '请选择'" :disabled="readonly" style="width: 100%">
                <el-option label="异地退货" :value="0"></el-option>
                <el-option label="本地退货" :value="1"></el-option>
                <el-option label="自退" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务员" prop="ClerkName">
              <el-input
                v-model="data.ClerkName"
                :placeholder="readonly ? '' : '请选择业务员'"
                :disabled="readonly"
                @focus="addEmp"
                readonly
                style="width: 220px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="物流公司" prop="BrandCode">
              <el-input v-model="data.BrandCode" :placeholder="readonly ? '' : '请输入物流公务'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="仓库" prop="WarehouseId">
              <select-input placeholder="选择仓库" :label="data.WarehouseName" v-model="data.WarehouseId" @click="openWarehouse" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="物流费用" prop="ActualFreight">
              <span>{{ data.ActualFreight }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" :placeholder="readonly ? '' : '请输入备注'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <dialog-list ref="dialogList" :info="data" @getList="getList" :readonly="readonly" />
        </el-row>
        <el-col :span="6">
          <el-form-item label="无税金额" prop="NoTaxAmount">
            <span>{{ $commonJs.toThousands(data.NoTaxAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="税额" prop="TaxAmount">
            <span>{{ $commonJs.toThousands(data.TaxAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单金额" prop="Amount">
            <span>{{ $commonJs.toThousands(data.Amount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="退款金额" prop="ReceiptAmount">
            <span>{{ $commonJs.toThousands(data.ReceiptAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="剩余金额" prop="RemainAmount">
            <span>{{ $commonJs.toThousands(Math.floor(data.RemainAmount * 100) / 100) }}</span>
          </el-form-item>
        </el-col>

        <el-row>
          <el-row>
            <el-col :span="24">
              <el-divider />
              <span style="margin-left: 16px; line-height: 50px">退款信息</span>
              <el-button type="primary" icon="el-icon-plus" circle @click="add" style="float: right; margin: 10px 15px 10px 0" v-if="!readonly"></el-button>
            </el-col>
          </el-row>
          <el-row v-for="(item, index) in recList" :key="index">
            <el-col :span="6">
              <el-form-item label="退款方式" prop="SettleId">
                <el-select v-model="item.SettleId" :placeholder="readonly ? '' : '请选择'" :disabled="readonly" clearable>
                  <el-option v-for="set in settleList" :key="set.SettleId" :label="set.SettleName" :value="set.SettleId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退款账号" prop="AccountId">
                <el-select v-model="item.AccountId" :placeholder="readonly ? '' : '请选择'" :disabled="readonly" clearable>
                  <el-option v-for="acc in accountList" :key="acc.AccountId" :label="acc.Bank + acc.AccountNumber" :value="acc.AccountId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="退款金额" prop="ReceiptAmount">
                <el-input
                  v-model="item.ReceiptAmount"
                  type="number"
                  @blur="onBlur(item, 'ReceiptAmount')"
                  @focus="onFocus(item, 'ReceiptAmount')"
                  @input="recChange(index)"
                  :disabled="readonly"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-link :underline="false" @click="del(index)" v-if="!readonly">
                <i class="el-icon-delete" style="margin-left: 30px; line-height: 30px; font-size: 18px"></i>
              </el-link>
            </el-col>
          </el-row>
        </el-row>
      </template>
      <template slot="footer">
        <!-- <el-button  type="danger" @click="cancelExamine" v-if="data.Status==2&&canExa">弃 审</el-button>
        <el-button  type="danger" @click="examine" v-else-if="canExa">审 核</el-button>-->
        <el-button type="danger" @click="cancelExamine" v-if="data.Status == 2 && canExa">弃 审</el-button>
        <el-button type="danger" @click="examine" v-else-if="canExa">通 过</el-button>
        <el-button @click="close" v-if="readonly">关 闭</el-button>
      </template>
    </common-dialog>
    <!-- <sa-dialog ref="saDialog" in-dialog selectable @select="setSa" /> -->
    <doc-dialog ref="docDialog" in-dialog selectable @select="setOrder" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <warehouse-dialog ref="warehouseDialog" in-dialog selectable @select="setWarehouse" title="仓库列表" :typeList="[1, 2]" />
  </div>
</template>
<script>
import customer from '@/components/common/customer/customer'
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import dialogList from './dialogList'
// import saDialog from "@/components/sales/business/salesorder/saListDialog";
//import orderDialog from "@/components/mall/worder/allSaOrder/orderListDialog";
import docDialog from './docListDialog'
import warehouseDialog from '@/components/basicinfo/basic/warehouse/listDialog'
import empDialog from '@/components/sales/business/empDialog'
import invoiceSelect from '@/components/basedoc/invoice/select'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    warehouseDialog,
    // saDialog,
    //orderDialog,
    empDialog,
    invoiceSelect,
    customer,
    docDialog
  },
  data() {
    return {
      data: {
        DocId: 0,
        DocNo: '',
        DocDate: '',
        SaDocId: 0,
        CustomerId: '',
        CustomerName: '',
        SaDocNo: '',
        InvoiceType: null,
        InvoiceNo: '',
        InvoiceAmount: '',
        FreightMode: 0,
        Remark: '',
        ActualFreight: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        ReceiptAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        ReceiptConditionId: null,
        ClerkName: '',
        ClerkId: 0,
        OrderNo: '',
        OrderId: 0,
        Status: 0,
        Goods: [],
        ShowTax: 0,
        OutStatus: 0,
        CompleteStatus: 0,
        ReceiptStatus: 0,
        InvoiceStatus: 0,
        WarehouseId: 0,
        WarehouseName: 0
      },
      canExa: false,
      noEdit: false,
      recList: [],
      tableData: [],
      accountList: [],
      settleList: [],
      recCon: [],
      recDel: [],
      cList: [],
      api: require('@/api/sale/saBackDoc').default,
      recApi: require('@/api/sy/RecCon').default,
      settleApi: require('@/api/sale/settle').default,
      accountApi: require('@/api/sale/account').default,
      billApi: require('@/api/sy/bill').default,
      addressApi: require('@/api/ba/address').default,
      readonly: false,
      rules: {
        // OrderNo: [{ required: true, message: "销售单号不能为空" }],
        // ClerkName: [{ required: true, message: "业务员不能为空" }],
        CustomerId: [{ required: true, message: '客户名称不能为空' }],
        InvoiceType: [{ required: true, message: '票据类型不能为空' }],
        InvoiceNo: [{ required: true, message: '发票号码不能为空' }],
        InvoiceAmount: [{ required: true, message: '发票金额不能为空' }]
      }
    }
  },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime())
    let today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    if (!this.data.DocDate) {
      this.data.DocDate = today
    }
    this.settleApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.settleList = res.Data
    })
    this.accountApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.accountList = res.Data
    })
    this.recApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.recCon = res.Data
    })
  },
  methods: {
    setSupplier(data) {
      this.data.CustomerId = data.TradeUnitId
      this.data.CustomerName = data.TradeUnitName
      this.data.CustomerType = data.TradeUnitType
      if (data.EmpId == 0) {
        this.data.ClerkId = 1054
        this.data.ClerkName = '公司'
      } else {
        this.data.ClerkId = data.EmpId
        this.data.ClerkName = data.EmpName
      }
      this.addressApi.list({ TradeUnitId: data.TradeUnitId }).then(res => {
        if (res.Code == 0) {
          this.addressList = res.Data
          if (res.Count > 0) {
            this.data.Person = res.Data[0].Person
            this.data.Phone = res.Data[0].Phone
          }
        } else {
          this.$message.warning(res.Msg)
        }
      })
      let tableData = this.$refs.dialogList.tableData

      let newData = tableData.filter(x => {
        if (x.GoodsId > 0) {
          return x
        }
      })

      if (newData.length > 0 && this.data.CustomerId > 0) {
        this.$confirm('是否更新商品报价', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var ids = newData.map(x => x.GoodsId)
          console.log(ids)
          if (ids.length > 0) {
            //获取所有商品报价
            this.api.GoodsOfferList({ CustomerId: this.data.CustomerId, GoodsIds: ids }).then(res => {
              if (res.Data.length > 0) {
                res.Data.forEach(x => {
                  tableData.forEach((g, index, tables) => {
                    if (g.GoodsId == x.GoodsId) {
                      tables[index].T = tables[index].T == 0 ? 0 : 1
                      tables[index].Offer = x.GoodsOffer
                      tables[index].Price = x.GoodsOffer

                      // 更新金额
                      let dis = tables[index].Discount > 0 ? Number(tables[index].Discount) : 100
                      let qua = tables[index].Quantity1 ? Number(tables[index].Quantity1) : 0
                      tables[index].Amount = ((tables[index].Price * qua * 100) / 100).toFixed(2)
                      tables[index].NoTaxAmount = (tables[index].Offer * (dis / 100) * tables[index].Quantity1).toFixed(2)
                      this.getList(this.$refs.dialogList.tableData)
                    }
                  })
                })
              }
            })
          }
        })
      }
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null
    },
    invoiceChange(e, data, type) {
      this.data.NeedInvoice = data.NeedInvoice
      if (!data.NeedInvoice) {
        this.data.InvoiceNo = ''
        this.data.InvoiceAmount = ''
      }
      this.$nextTick(() => {
        this.$refs.dialogList.setDefTaxRate(data.DefTaxRate, type)
      })
    },
    openWarehouse(e) {
      this.$refs.warehouseDialog.open().then(that => {
        that.getData({})
        that.getTree()
      })
    },
    setWarehouse(e) {
      this.data.WarehouseId = e.WarehouseId
      this.data.WarehouseName = e.WarehouseName

      this.$refs.dialogList.ChangeWarehouseId(e.WarehouseId)
    },
    addOrder() {
      this.$refs.docDialog.open().then(that => {
        that.getData({ Status: 2, MonthlyClosing: true })
      })
    },
    setOrder(e) {
      this.data.SaDocNo = e.DocNo
      this.data.SaDocId = e.DocId
      this.data.CustomerName = e.CustomerName
      this.data.CustomerId = e.CustomerId
      //this.$refs.dialogList.getDataFromOrder(e.DocId);
      this.$refs.dialogList.getDataFromDoc(e.DocId)
    },
    getList(list) {
      this.tableData = list
      let Amount = this.data.ActualFreight
      let TaxAmount = 0
      let ReceiptAmount = this.data.ReceiptAmount || 0
      list.forEach(item => {
        if (item.T != 2) {
          Amount += Number(item.Amount)
          TaxAmount += Number(item.TaxAmount)
        }
      })
      this.data.Amount = Amount
      this.data.TaxAmount = TaxAmount
      this.data.NoTaxAmount = Amount - TaxAmount
      this.data.RemainAmount = Amount - ReceiptAmount
    },
    recChange(index, type) {
      let ReceiptAmount = 0
      let Amount = this.data.Amount
      if (!Amount) {
        Amount = 0
      }
      this.recList.forEach(item => {
        if (item.ReceiptAmount) {
          ReceiptAmount += Number(item.ReceiptAmount)
        }
      })
      if (type != 'del') {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 1
        }
      }
      this.data.ReceiptAmount = Number(ReceiptAmount)
      this.data.RemainAmount = this.data.Amount - this.data.ReceiptAmount
    },
    add() {
      this.recList.push({
        T: 0,
        DocReceiptId: 0,
        OrderReceiptId: 0,
        OrderId: this.data.OrderId,
        SettleId: null,
        AccountId: null,
        ReceiptAmount: 0,
        AddTime: this.data.DocDate
      })
    },
    del(index) {
      this.$confirm('确认删除该行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 2
          this.recDel.push(this.recList[index])
        }
        this.recList.splice(index, 1)
        this.recChange(index, 'del')
      })
    },
    addEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData({ Status: 1 })
      })
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    examine() {
      if (!this.onBeforeSave()) return false
      this.$confirm('确认审核数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.examine(this.data.DocId).then(res => {
          if (res.Code == 0) {
            this.$message.success('审核成功')
            this.readonly = true
            this.close()
            this.$emit('close-saved')
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm('确认弃审数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.cancelExamine(this.data.DocId).then(res => {
          if (res.Code == 0) {
            this.$message.success('弃审成功')
            this.readonly = false
            this.close()
            this.$emit('close-saved')
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    onCreateOpened() {
      this.canExa = false
      this.readonly = false
      this.cList = JSON.parse(sessionStorage.getItem('cList'))
      this.recList = []
      this.$refs.dialogList.tableData = [
        {
          T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: '',
          GoodsName: '',
          GoodsId: '',
          Model: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 0,
          Quantity1: 0,
          Quantity2: 0,
          BatchNo: '',
          Offer: 0,
          Discount: 100,
          Price: 0,
          CostPrice: 0,
          CostPriceState: false,
          ExistQuantity: 0,
          AvailableQuantity: 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: 0,
          GrossProfit: 0,
          Remark: '',
          Thumbnail: '',
          OutQuantity: 0,
          AddTime: '',
          UnitId: '',
          UnitId1: '',
          UnitId2: ''
        }
      ]
      this.$refs.dialogList.tableDel = []
      var user = this.$store.state.user
      if (user) {
        this.data.ClerkId = user.empId
        this.data.ClerkName = user.name
      }
      this.billApi.getDefaultSerialNo('销货退货单').then(res => {
        if (res.Code == 0 && res.Data) {
          this.data.DocNo = res.Data
        } else if (res.Code == 0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    onEditOpened() {
      if (sessionStorage.getItem('check') === '1') {
        this.canExa = true
        this.readonly = true
        sessionStorage.removeItem('check')
      } else {
        this.canExa = false
        this.readonly = false
      }
      this.recList = []
      this.$refs.dialogList.tableData = []
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.getData()
      this.cList = JSON.parse(sessionStorage.getItem('cList'))
      if (this.data.ReceiptConditionId == 0) {
        this.data.ReceiptConditionId = null
      }
      this.api.getReceiptList(this.data.DocId).then(res => {
        res.Data.forEach(item => {
          if (item.SettleId == 0) {
            item.SettleId = null
          }
          if (item.AccountId == 0) {
            item.AccountId = null
          }
        })
        this.recList = res.Data
      })
    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData
      let tableDel = this.$refs.dialogList.tableDel
      let tb = []
      if (tableData.length == 0 || !tableData.some(v => v.GoodsId)) {
        this.$message.error('请添加商品')
        return false
      }
      for (var i = 0; i < tableData.length; i++) {
        if (tableData[i].GoodsId) {
          if (!tableData[i].WarehouseId) {
            this.$message.error('请选择仓库')
            return false
          }
          if (!tableData[i].GoodsName) {
            this.$message.error('请选择商品')
            return false
          }
          if (!(tableData[i].Quantity < 0)) {
            this.$message.error('请填写正确数量')
            return false
          }
          if (tableData[i].T === 0 || tableData[i].T === 1) {
            this.$delete(tableData[i], 'unit')
            this.$delete(tableData[i], 'Rate1')
            this.$delete(tableData[i], 'Rate2')
            tb.push(tableData[i])
          }
        }
      }
      this.data.Goods = tb.concat(tableDel)
      this.data.Goods = this.data.Goods.map(x => {
        return this.$commonJs.obj.removeNullKey(x)
      })
      // if(!this.data.RemainAmount&&this.data.RemainAmount!==0||this.recList.length==0) {
      //   this.$message.error("请填写退款信息");
      //   return false
      // }
      if (this.data.ReceiptConditionId === null) {
        this.data.ReceiptConditionId = 0
      }
      let rec = []
      this.recList.forEach(item => {
        if (item.T || item.T === 0) {
          rec.push(item)
        }
      })
      for (var i = 0; i < rec.length; i++) {
        if (!rec[i].SettleId) {
          this.$message.error('请选择退款方式')
          return false
        }
        if (!rec[i].AccountId) {
          this.$message.error('请选择退库账号')
          return false
        }
        if (!(rec[i].ReceiptAmount > 0)) {
          this.$message.error('退款金额须大于0')
          return false
        }
      }
      this.data.Receipts = rec.concat(this.recDel)

      return true
    }
  }
}
</script>
<style lang="scss">
.is-disabled {
  input,
  textarea {
    background-color: #fff !important;
    color: #333 !important;
  }
}
</style>
